/* eslint-disable */
import {Service} from 'components/Shared/server';
import {ICompareItem} from 'models/ICompareItem';
import {IRemoveCompareResponse} from 'models/IRemoveCompareResponse';

type CompareRequest = {productId: string; webCatalog: string;};

export const routePostIndex = () => `/api/compare`;
export function postIndex(add: CompareRequest): Promise<ICompareItem> {
  return Service.post<ICompareItem>({
    url: routePostIndex(),
    body: add
  });
}

export const routeDeleteRemove = (productId: string, articleGroup: string) => `/api/compare/${encodeURIComponent(articleGroup)}/${encodeURIComponent(productId)}`;
export function deleteRemove(productId: string, articleGroup: string): Promise<IRemoveCompareResponse> {
  return Service.remove<IRemoveCompareResponse>({
    url: routeDeleteRemove(productId, articleGroup)
  });
}

export const routeGetIndex = () => `/api/compare`;
export function getIndex(): Promise<ICompareItem[]> {
  return Service.get<ICompareItem[]>({
    url: routeGetIndex()
  });
}
